import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import HorizontalScroller from './HorizontalScroller';
import noImage from '../../assets/no-image-640x400.jpg';
import { safeRegionName } from '../../utils/safeRender';

const Card = styled(Link)`
  display:block; color:inherit; text-decoration:none;
  border:1px solid var(--bdr); border-radius:16px; overflow:hidden;
  background:var(--card); box-shadow:var(--shadow);
`;
const Pic = styled.div`
  aspect-ratio:4/3; background:#111;
  img{ 
    width:100%; 
    height:100%; 
    object-fit:cover; 
    display:block;
    /* Улучшаем качество изображений */
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    image-rendering: high-quality;
  }
`;
const Box = styled.div`
  padding:12px; display:grid; gap:6px;
  grid-auto-rows: min-content;
  min-height: 96px;
`;
const Title = styled.div`
  font-weight:700; font-size:16px; line-height:1.25;
  display:-webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow:hidden;
  min-height: calc(1.25em * 2);
  color: #000;
  background: var(--gold);
  opacity: 0.92;
  padding: 8px 12px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;
const Sub = styled.div` 
  opacity:.75; 
  font-size:13px; 
  white-space:nowrap; 
  overflow:hidden; 
  text-overflow:ellipsis; 
  min-height:1.2em;
  color: #000;
  background: var(--gold);
  opacity: 0.88;
  padding: 6px 10px;
  border-radius: 10px;
  backdrop-filter: blur(6px);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  display: inline-block;
  margin-top: 4px;
`;

function normalize(x){
  if (!x) return null;
  
  // Приоритет оригинальным изображениям высокого качества
  const img =
    x.cover_url ||      // Оригинал высокого качества
    x.cover_thumb ||    // Превью (только если нет оригинала)
    x.image ||
    x.images?.[0]?.url ||
    noImage;

  const id = x.id ?? x.slug ?? Math.random();
  const title = String(x.title || x.name || x.title_ru || x.title_en || 'Район');
  const city  = String(x.city || x.city_name || safeRegionName(x.region) || '');
  const to    = x.slug ? `/search?district=${x.slug}` : (x.id ? `/search?district_id=${x.id}` : '#');

  return { id, title, city, to, img };
}

export default function DistrictsSlider({
  items = [],
  perViewDesktop = 4,
  perViewTablet  = 3,
  perViewMobile  = 2,
  perViewTiny    = 2,
  itemMin = 260,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const list = (Array.isArray(items) ? items : [])
    .map(normalize)
    .filter(Boolean);

  if (!list.length) return null;

  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidthValue}
      centered
      pad={pad}
      gap={gap}
      limitDesktopWidth={shouldLimitDesktop}
    >
      {list.map((it) => (
        <div key={String(it.id)} style={{ width: 'var(--col-width)' }}>
          <Card to={it.to}>
            <Pic><img src={it.img} alt={String(it.title)} loading="lazy" decoding="async" /></Pic>
            <Box>
              <Title>{it.title}</Title>
              {it.city ? <Sub>{it.city}</Sub> : <div style={{height:'1.2em'}} />}
            </Box>
          </Card>
        </div>
      ))}
    </HorizontalScroller>
  );
}
